import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Slide from "@material-ui/core/Slide";
import { DataProxy } from "apollo-cache";
import { Field, Formik, FormikActions, FormikProps } from "formik";
import React, { useState } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";
import FormikInputText from "../../../componentes/MaskedInput/FomikInput";
import SnackMessage from "../../../componentes/SnakBar";
import {
  EditarEstabelecimentoProps,
  GetPainelCadastroDocument,
  ListarEstabelecimentosDocument,
  ListarEstabelecimentosQuery,
  withEditarEstabelecimento,
} from "../../../graphql/components";
import { IState } from "../../../redux/reducers";

const Transition = React.forwardRef<unknown, React.ComponentProps<typeof Slide>>(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...(props as React.ComponentProps<typeof Slide>)} />;
});

const Schema = Yup.object().shape({
  codEstabelecimento: Yup.string()
    .nullable(true)
    .required(`Código do estabelecimento é obrigatório.`),
  apelidoLoja: Yup.string(),
});

interface Props {
  isOpen: boolean;
  close: () => void;
  nomeOperadora: string | null;
  codEstabelecimento: string | null;
  apelidoLoja: string;
  codOperadora: number | null;
  codPessoa: number | null;
  index: number | null;
}

export const EditEstabelecimento: React.FunctionComponent<EditarEstabelecimentoProps<Props>> = ({
  isOpen,
  close,
  nomeOperadora,
  codEstabelecimento,
  apelidoLoja,
  codOperadora,
  codPessoa,
  index,
  mutate,
}) => {
  const [message, setMessage] = useState("");
  const [openSnackMessage, setOpenSnackMessage] = useState(false);

  const [variantSnack, setVariantSnack] = useState<"success" | "warning" | "error" | "info">("success");

  const closeSnackMessage = React.useCallback(() => setOpenSnackMessage(false), []);

  const save = React.useCallback(
    async (values: FormValues, actions: FormikActions<FormValues>) => {
      try {
        const response = await mutate({
          refetchQueries: [
            {
              query: GetPainelCadastroDocument,
            },
          ],

          variables: {
            codExterno: values.codEstabelecimento.toString(),
            codExternoAntigo: codEstabelecimento != null ? codEstabelecimento : undefined,
            codOperadora: codOperadora!,
            codPessoa: codPessoa!,
            apelido: values.apelidoLoja,
          },

          update: (store: DataProxy, { data }) => {
            if (data!.editarEstabelecimento.mensagemTela === "SUCESSO") {
              const oldResult = store.readQuery<ListarEstabelecimentosQuery>({
                query: ListarEstabelecimentosDocument,
                variables: { values: { codoperadora: codOperadora! } },
              });
              if (oldResult) {
                oldResult.listarEstabelecimentos[index!].conciliadores.apelido = values.apelidoLoja;
                oldResult.listarEstabelecimentos[index!].display = "none";
                oldResult.listarEstabelecimentos[index!].conciOperadora.codexterno = values.codEstabelecimento
                  ? values.codEstabelecimento!.toString()
                  : undefined;
                store.writeQuery({
                  query: ListarEstabelecimentosDocument,
                  data: oldResult,
                  variables: { values: { codoperadora: codOperadora! } },
                });
              }
            }
          },
        });
        if (response) {
          if (
            response.data!.editarEstabelecimento.mensagemTela === "PAINEL_CADASTRO" ||
            response.data!.editarEstabelecimento.mensagemTela === "SUCESSO"
          ) {
            setMessage("Registro salvo com sucesso!");
            setVariantSnack("success");
            setOpenSnackMessage(true);
            actions.setSubmitting(false);
            close();
          } else {
            setMessage(response.data!.editarEstabelecimento.mensagemTela!);
            setVariantSnack("warning");
            setOpenSnackMessage(true);
            actions.setSubmitting(false);
          }
        }
      } catch (e) {
        setMessage("Erro ao processar sua requisição!");
        setVariantSnack("warning");
        setOpenSnackMessage(true);
        actions.setSubmitting(false);
      }
    },
    [close, codPessoa, codEstabelecimento, codOperadora, index, mutate]
  );
  const initialValues = {
    codEstabelecimento: codEstabelecimento != null ? codEstabelecimento : "",
    apelidoLoja,
  };
  type FormValues = typeof initialValues;
  return (
    <React.Fragment>
      <Dialog
        open={isOpen}
        onClose={close}
        aria-labelledby="form-dialog-title"
        disableBackdropClick={true}
        TransitionComponent={Transition as any}
      >
        <DialogTitle id="form-dialog-title" style={{ marginBottom: 10 }}>
          Contrato
        </DialogTitle>
        <Formik
          initialValues={initialValues}
          onSubmit={save}
          validationSchema={Schema}
          render={(formikBag: FormikProps<FormValues>) => (
            <form autoComplete="new-password" role="presentation" onSubmit={formikBag.handleSubmit}>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} style={{ marginBottom: 15 }}>
                    Operadora: &nbsp;<b>{nomeOperadora}</b>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Field
                      id="codEstabelecimento"
                      name="codEstabelecimento"
                      component={FormikInputText}
                      label="Código do estabelecimento"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Field id="apelidoLoja" name="apelidoLoja" component={FormikInputText} label="Apelido loja" />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={close} color="secondary" disabled={formikBag.isSubmitting}>
                  Cancelar
                </Button>
                <Button type="submit" color="primary" disabled={formikBag.isSubmitting}>
                  Salvar
                </Button>
              </DialogActions>
            </form>
          )}
        />
      </Dialog>
      {message.length > 0 && (
        <SnackMessage open={openSnackMessage} close={closeSnackMessage} variant={variantSnack} message={message} />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state: IState) => ({
  ...state,
  codOperadora: state.painelCadastroReducer.codOperadora,
  nomeOperadora: state.painelCadastroReducer.nomeOperadora,
});

const withEditarEstabelecimentoMutation = withEditarEstabelecimento<Props>({});

const withMutation = withEditarEstabelecimentoMutation(EditEstabelecimento);

const EditEstabelecimentoMapped = connect(
  mapStateToProps,
  null
)(React.memo(withMutation));

export default React.memo(EditEstabelecimentoMapped) as React.ComponentType<Props>;
